export default __webpack_public_path__ + "static/media/Sellie-1.a71079f2.jpeg";